import styled from 'styled-components';

export const Container = styled.div`

`;

export const Content = styled.div`
	width: 250px;

	border: 1px solid #B6B6B6;
	border-radius: 16px;

	img{
		width: 100%;
		height: 170px;
		object-fit: cover;
		background-color: #ececec;

		border-radius: 16px 16px 0 0;
	}

	.slick-prev:before,
    .slick-next:before {
      color: #212121;
    }

	.slick-prev, 
	.slick-next{
		background: #FFF;
		position: absolute;
	    top: 50%;
	    z-index:1;
	    border-radius: 50%;
	}

	.slick-next{
		right: 8px;
	}

	.slick-prev{
		left: 8px;
	}

	.slick-dots li button:before {
	   	color: #212121;
	}

	.slick-dots{
		bottom: 12px;
	}

	@media(max-width: 767px){
		width: 250px;
	}

	@media(min-width: 1441px){
		width: 270px;

		img{
			height: 190px;
		}
	}
`;

export const LocalAndActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	flex-direction: column;

	text-align: center;

	padding: 14px 0 16px;

	border-bottom: 1px solid #B6B6B6;

	>h2{
		width: 80%;

		font-size: 15px;
		font-weight: bold;
		color: #6EA5FF;
	}

	>p{
		width: 80%;
		
		font-size: 11px;

		margin: 12px 0 18px;
	}

	@media(min-width: 1441px){
		padding: 18px 0 18px;

		>h2{
			font-size: 17px;
		}

		>p{
			font-size: 12px;

			margin: 8px 0 22px;
		}
	}
`;

export const HourAndActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	flex-direction: column;

	text-align: center;

	padding: 16px 0;

	>h2{
		font-size: 14px;
		font-weight: bold;
		color: #DD6435;

		margin-bottom: 3px;
	}

	>p{
		font-size: 11px;

		margin-bottom: 28px;
	}

	@media(min-width: 1441px){
		>h2{
			font-size: 16px;
		}

		>p{
			font-size: 12px;

			margin-bottom: 32px;
		}
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	button{
		background: transparent;

		transition: all 0.5s;

		font-size: 11px;
		color: #B6B6B6;

		border: 0;
	}

	>p{
		font-size: 11px;

		margin: 0 6px;

		color: #B6B6B6;
	}

	button#reSchedule-button{
		&:hover{
			color: #6EA5FF;
		}
	}

	button#cancel-button{
		&:hover{
			color: #FF3838;
		}
	}
`;